import { useEffect, useState } from "react";
import { CertifiedAuthorStyle } from "./style";
import { useNavigate } from "react-router";
import { apiGetAuthWriterDetail } from "api/user/auth-writer";
import { CertifiedAuthorDetailResponse } from "types/user/auth-writer";
import { message } from "antd";

const CertifiedAuthor = () => {
  const navigate = useNavigate();
  const [detail, setDetail] = useState<CertifiedAuthorDetailResponse>();

  const interest = [
    {
      icon: "https://cdn-prd.ggac.com/ggac/icon/certified/icon-light.png",
      text: ["曝光机会"],
    },
    {
      icon: "https://cdn-prd.ggac.com/ggac/icon/certified/icon-zan.png",

      text: ["首页推荐"],
    },
    {
      icon: "https://cdn-prd.ggac.com/ggac/icon/certified/icon-cooper.png",

      text: ["合作机会"],
    },
    {
      icon: "https://cdn-prd.ggac.com/ggac/icon/certified/icon-envelope.png",

      text: ["工作邀约"],
    },
    {
      icon: "https://cdn-prd.ggac.com/ggac/icon/certified/icon-rocket.png",

      text: ["新功能抢先体验"],
    },
    {
      icon: "https://cdn-prd.ggac.com/ggac/icon/certified/icon-moreAtten.png",

      text: ["更多关注"],
    },
    {
      icon: "https://cdn-prd.ggac.com/ggac/icon/certified/icon-integral.png",

      text: ["200G分"],
    },
  ];

  const toMaterial = () => {
    if (detail?.compeleteStatus === 0) {
      message.warning(`上传作品数量不足`);
      return;
    }
    if ([2, 3].includes(detail?.status!)) {
      navigate(`/user-center/certified-author/material`);
    }
  };

  const getDetail = () => {
    apiGetAuthWriterDetail(1).then((res) => {
      setDetail(res);
    });
  };

  const toUpload = () => {
    if (detail?.compeleteStatus === 0) {
      navigate("/work/create");
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <CertifiedAuthorStyle>
      <div className="authent-author">
        <div className="authent-author-top">
          <img src="https://pre-cdn-hz.ggac.com/images/wxApp/ident/logo.png" alt="" />
          <div className="welcome">
            欢迎您入驻G站，成为认证作者可以获得更多关注、曝光以及合作机会
          </div>
        </div>
        <div className="authent-author-bottom">
          <div className="interest">
            <div className="authent-title">认证权益</div>
            <div className="interest-cnt">
              {interest.map((item, index) => {
                return (
                  <div className="interest-cnt-item" key={index}>
                    <div className="cover">
                      <img className="iconfont" src={item.icon} alt="" />
                    </div>
                    <div className="text">
                      {item.text.map((ele, index) => {
                        return <p key={index}>{ele}</p>;
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="step">
            <div className="authent-title">认证步骤</div>
            <div className="authent-entitle">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAdAAAAAeCAYAAACcyE9wAAAI9UlEQVR4nO1dbWsbORBW45gYk8UkhISSEq4c3G+an7i/6b70CA0hJTgYG+NgXA6ls0HZzGi1elutrAfK9Vx7tXp2XqSZ0ewXYQgAmAshZuq367pemv5eBQBcEh/v6rreGvx2IYSYtD4+1HW96viOCz5cXzeGCScUl7rf+pxPzzG2dV3vTK5rOqfUn03rOnI+cl5nyvX2+MeYG831nXQqIy7XdV3ve14virzGAADIeZzjfObKkAchxKsibwcLTlwQzK56tnXymb928cPBhf/THuNctQUOAPZ1Xa8t7vmK+OxZ3qTBb6vWJAX+btXxHRe0r68bw0QBZwwH3G99zqfPGHsAuDcUTNM5pf5sGiWWi7xpx/fk2EuThR8DV53KhcsrCy5jyWswAMAUuVl0zPMNACDlYqXhKLQ8DGWHjGDAzwf44P+kx0CfVmueH1ZBepDP/eJYnotciQLANyHETZfzREj5/wYAlCHuGitrnYrJpYLRyCsASMN812G826gajnDXVPARlakM+eLfyIFqBjkvDzJ7XGK4K2ugHN9aOrBLJi2hQ7Y65YHLG4fhk5dXNN5fHcKhl/j7AoYfnQz55N/UgVbM503suCBvuOwKxoKvzI7QBDsi9NmFnHXKhUuJhcWCREWy8oqLi2vHyxww5VXAY4GOMij/nTlQXM3pQjCVhfEIjbUmnzplVv8rTBZTsEpOR0AsJZpJg+apwCK5Z4N5Om7XssV7bsaf4T02OiGd50OfAgaPOpUblyouZM6pb3FRc12P8uobXJHMHvOCeyxcOWvmgnw2nB5Q3qhiqaHkIYYd4saYKgVAbVwjJyq88m9SRMStlBvMZT7HUtCDoF1JqAKNFyVIa4dikKHmGdNAvBV6uFaeJvpsuHCqLBh4an22BYAV7nLO+jpPhBedyojLW2LHOsFr2RpnL/IaAFR0QT7ndvHTVvnvEndTUuYeuTkNJQ8x7JBuDAB45mRILuhavHjl38SBmoSTqpjVawWDQa7o7nOiX1PMsyUM/htQ0Z5kOMiydD5LnbLlEgAehBB/ETuDynF3k6K8Uvwsu+QIK7NtTjxkD5ShRyHEd2Ku7eiGV/61OdAeZ3L6VDIVjBczx9xUiuBydZ3GysZ5Zq5TVlwijxvin6aOBVVjkddkondjBUZrKB5NcvHW/HcVEVG5jDURG5/iQemC/HGBO41cwM3lNdD8ctYpFy65UOsZ87kpxiCv5SSDH9g6Qmv+WQeKKz8qV7NhVoulGvc4MMGzfVkjRO7sWHXKkMtQu7AxyOtFOQ7oBbYLJWv+dTtQKoR0wFgwlXQuYdzjwRxDkTnA9CiXD+SuUyG49OFYUpJXajEhIw138h5LJM8Omsr2tl555V9XREStft9WyVLhAeC6Jdyy4qmybO2XDbD7She8hJQMx3pDXdc/LYd5Zs7VySrHjW3/yYQQ02DlrlMhuOyrK6nL64bhadrslAFAKH2Cd0ov1iRzpZHskG78uaaxRJszr/yTDlRXTaf8fYUdGVTMS6VY1FZswceS5eMAcM4cM5AG/zH0PeSAolNxMAJ5XWnOvqqY4p93HcderC8JHs0Jboc0Tnqq4ZLqK+2Vfy7kogs1NaByNosSy88Sv5hJVVS3jwISRafiIVl5xR3wo2XTiqoJNQa4tdQxZ/7oHOGno1O++eccKFfooN7Ijkn8l2KizIDPmjuTeF0MvBGKTkVC6vKK9/efQwe3m7Jw7cQT1yDCJ/+fHKgmGUuFkajPyoPNEy+McZ8c0xtbbFB0ahAkLa9yJ4TNJX4or3Lsk+M8hv7UNjhgtyCtc/TFP5UDpZR1z3jzDZWzSa21X0zUdf1v13B4uNtZAUzG8gXs9iEFjspFXBq+yzVFxCgqORadSqagbCzyis90qe6YsRL0BPO4VD5X4DnhJArMYtohDfa4o1z1KRRz5Z9yoFS4iHxIcissXwBMrK5La78MIQ0+ACwJAy9G/B7L1wg7vGPRqRBcWhfMjFVelSKVpg8rt+DOqaFJF3TVu68+q6v78P/BgWrajM01VVBUHnVRHGi2eNG80aCghaJTfxpIDHh8ZPTyipXFVOXo/Fjs7JAv+tDx31ZUblU201RBUYJZWvtlCjSEXJVjNvD4UuaiU2bt+Li5/XYZOCN5Lf1yhwXJ/7sD1bQZs4Wu1JpajXZWGuI9UgapCFdEZPZmCC5E6OxAI+tUCnDhktR/H2cey5tMCkJB3YH6Vk6dQ6TOu80MSrO56rnUDhYfA34l/KJxY2BoiJqHtq2X/DeD83gxdWpwOHC5YHagPp1eMvKKLeO+m0YU8HvUImSshXuDwif/qgP1rZwTjUPkFOOaMkpyJY+JXKoYgHsVUkFAYGjsJROOKfmRu8dbKpSLsniL58F0TjKmTqUCGy65Zu/eHEQq8orycoP5NHko/6ZjcVGhrFEoG4ee8M3/qdC3GZMvGjV6oS0A/E3kbs4pZ4nVcVvCq0/QKF21XoGkCwG9ZNCP1QoA8E/f3/ksOcfk+nzEFbgNliirbfmV//8Nq2KbNMFZ63tSXkX73FlsnUoILlyq2HWd5euLoeVVMd4qFrhDF8SCoYufJHagQ9shU4Tgv9mBcqvoPjs76ruVpuvHkyakMmkVVXCQDX5Lte+w0D3HUQDPgumc2rSjwIfaiQ6hU4PDA5cC5SlU4c8g8orPrOvst0kxmQjMT5YIxX/jQLmD3n1CBNxqiCsOkIr24CDMu9LIfHjgcxx9KBd3O596ZxriQLw0OrpOpQIPXD6Eapg+lLxilOzBQ8GjvM5zgg3lk0Yo/k96thljgZVuZAGB5jdNT8K+oQg5gftjDd2mBowCjF6h0fD/7KlkUnbvVYM2pE6lAl9chsBQ8orzunc4u7nFxYXX0PaxIAT/p5oye5vCnA2h3DNdGzJ0gj/R6FRM/kSgIq6xVVM5tpIeZEjjbuyTwLzSDwzJVpoUgpTFDdNKbVCdSgWGXB7QMK0i5/QGkVe0d88AsFI40aWp9sjPOpWc55jhm/8vKXKBBRjvK/giOAVDQumNKfG7hM/s0eJyXxbDf4A5unbDCa8t6go88y+E+B8A6wrh3aNISQAAAABJRU5ErkJggg==" alt=""/>
            </div>
            <div className="step-cnt">
              <div className="list-item">
                <div className="title">01</div>
                <div className="desc">
                  <div>上传至少{detail?.count}幅，您认为最能展示您</div>
                  <div>能力的作品</div>
                </div>
                <div className="btn" onClick={toUpload}>
                  {detail?.compeleteStatus === 0 ? "上传作品" : "已完成"}
                </div>
                <div className="finish">
                  完成进度：
                  {detail?.workCount! > detail?.count!
                    ? detail?.count
                    : detail?.workCount}
                  /{detail?.count}
                </div>
              </div>
              <div className="list-item">
                <div className="title">02</div>
                <div className="desc">
                  <div>提交认证信息</div>
                </div>
                <div className="btn" onClick={toMaterial}>
                  {detail?.status === 0
                    ? "待审核"
                    : detail?.status === 1
                    ? "已认证"
                    : detail?.status === 2
                    ? "驳回"
                    : "立即提交"}
                </div>
                {detail?.status === 2 && (
                  <div className="finish">驳回原因：{detail?.refuseReason}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CertifiedAuthorStyle>
  );
};

export default CertifiedAuthor;
